/**
 Intended for use with mock data
 **/

var fitt = require('fitt'),
fs = require('fs'),
utils = require('../core/utils.js');


function mock(url, config) {
    return new Promise(function (resolve, reject) {
        // change url to be the path + filename of file on disk
        if (url) {
            fs.readFile(url, 'utf8', function (err, data) {
                if (err) {
                    reject(utils.createError(
                    'Mock data request failed.',
                    url,
                    config));

                } else {
                    var response = JSON.parse(data);
                    resolve(response);
                }
            });
        } else {
            console.log('Mock data dispatch used but no file path provided.');
        }
    });
}


if (typeof module !== fitt.TYPE_UNDEF) {
    module.exports = mock;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/dispatch/mock.js
// module id = 766
// module chunks = 0